import React from 'react';

import { flagStyles } from '../settings';

const SvgSM = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-4848px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgSM;
